import React, {Fragment} from 'react'
import styles from './Analyze.scss'
import {Card} from 'common/styleguide/Card'
import {CTA} from 'common/styleguide/CTA'
import {ColWrap} from 'common/layouts/SideNavLayout/TwoCol'
import analyzeGraphic from './analyze-graphic.svg'
import {currentUserHasPrivilege, getCurrentUser} from 'lib/utils'
import Helmet from 'react-helmet'

export class Analyze extends React.PureComponent {
  componentDidMount () {
    // if user can access ride center but somehow wound up here, redirect on mount!
    if (currentUserHasPrivilege('activity_center')) {
      window.location.href = `${window.location.origin}/activities`
    }
  }

  render () {
    return (
      <ColWrap>
        <Helmet title='Analyze · Ride with GPS' />
        <div>
          <h2 data-heading-alt>Analyze</h2>
          <Card className={styles.card}>
            <img className={styles.graphic} src={analyzeGraphic} alt='ride analysis symbol' />
            <h1 data-heading-alt>Analyze Your Rides</h1>
            <div className={styles.leadText}>
              <h2>
                Premium subscribers can access the Ride Center to analyze rides
                and manage ride data in bulk.
              </h2>
            </div>
            <CTA inline primary href='https://ridewithgps.com/help/ride-center' target='_blank' margins={false}>Learn More</CTA>
            {getCurrentUser().eligibleForOnetimeTrial && <Fragment>
              <div className={styles.trialText}>
                <h2>
                  Interested in a 7 day trial of all Premium features? No credit card required!
                </h2>
              </div>
              <CTA inline secondary href='/start_trial' margins={false}>Start Trial</CTA>
            </Fragment>}
          </Card>
        </div>
      </ColWrap>
    )
  }
}
